import React from 'react';
import { InputGroup, InputProps as RsInputProps } from 'rsuite5';
import { Icon } from 'rsuite';
import { FieldProps } from 'formik';
import { Input } from '../formik-rsuite';

export interface InputProps extends Omit<RsInputProps, 'form'>, FieldProps {}

const BicesterInput = ({
  field,
  form,
  className,
  style,
  placeholder = '',
  inputPrefix,
  type,
  inputAs,
  onChange,
  onPressEnter,
  cleanable = false,
  onClean,
  ...props
}: {
  className?: string;
  style?: any;
  placeholder?: string;
  inputPrefix?: string;
  type?: string;
  inputAs?: React.ElementType<any>;
  onChange?: (value: string) => void;
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>;
  cleanable?: boolean;
  onClean?: () => void;
  [rest: string]: any;
} & InputProps) => {
  return (
    <InputGroup>
      {inputPrefix && <InputGroup.Addon>{inputPrefix}</InputGroup.Addon>}
      <Input
        field={field}
        form={form}
        className={className}
        style={style}
        type={type}
        as={inputAs}
        placeholder={placeholder}
        onPressEnter={onPressEnter}
        name={field.name}
        value={field.value}
        onChange={(value, event) => {
          form.setFieldValue(field.name, value);
          field.onChange(event);
          onChange && onChange(value);
        }}
        onBlur={field.onBlur}
        {...props}
      />
      {Boolean(field.value && cleanable) && (
        <InputGroup.Addon
          style={{
            padding: '0 11px 0 0',
            backgroundColor: 'transparent',
            position: 'absolute',
            zIndex: 2,
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <Icon
            className="cursor-pointer"
            icon="close"
            onClick={() => {
              form.setFieldValue(field.name, '');
              onClean?.();
            }}
          />
        </InputGroup.Addon>
      )}
    </InputGroup>
  );
};

export default BicesterInput;
